<div khA11yDialog>
<div class="modal-heading modal-heading-1">
  <div khA11yLabelSource class="label_name">
    {{ logicalError.SubjectName }}
  </div>
</div>
<div class="modal-body remediation-modal">
  <div *ngIf="show">
    <div *ngIf="logicalError.StruggleReasons" class="well spacer-sm">
      <kh-img path="question-mark.png" class="remediation-modal__icon" khA11yHidden></kh-img>
      <b>{{ 'REMEDIATION_MODAL.WHY_SOME_STUDENTS_STRUGGLE' | translate }}</b>
      <ol class="text-smp">
        <li *ngFor="let struggleReason of logicalError.StruggleReasons" [innerHtml]="struggleReason"></li>
      </ol>
    </div>

    <div [khA11yDisclosure]="showLearnMore" *ngIf="logicalError.Documents.length">
      <p class="spacer-md">
        {{ 'REMEDIATION_MODAL.SEE_THE_TEACHER_SUPPORTS_AVAILABLE' | translate }}
        <button khA11yDisclosureTrigger class="remediation-modal__link-button cursor ul" (click)="showLearnMore = !showLearnMore">{{ 'REMEDIATION_MODAL.LEARN_MORE' | translate }}</button><br>
      </p>

    <div khA11yDisclosurePanel class="alert alert-info spacer-sm animate-show" *ngIf="showLearnMore" animate.enter="kh-collapse-enter" animate.leave="kh-collapse-leave" khA11yAlert>
      <ng-container *ngFor="let document of logicalError.Documents">
        <ng-container [ngSwitch]="document.DocumentType">
          <div *ngSwitchCase="documentType.ResponsiveIntervention">
            <b>{{ 'REMEDIATION_MODAL.RESPONSIVE_INTERVENTION_RESOURCE' | translate }}</b>
            <p class="text-smp">
            </p>
          </div>
          <div *ngSwitchCase="documentType.MathBackground">
            <b>{{ 'REMEDIATION_MODAL.MATH_BACKGROUND' | translate }}</b>
            <p class="text-smp">
              {{ 'REMEDIATION_MODAL.THE_MATH_BACKGROUND_DOCUMENT_EXPLAINS' | translate }}
            </p>
          </div>

          <div *ngSwitchCase="documentType.MisconceptionChart" class="spacer-sm">
            <b>{{ 'REMEDIATION_MODAL.MISCONCEPTION_CHART' | translate }}</b>
            <p class="text-smp">
              {{ 'REMEDIATION_MODAL.THE_MISCONCEPTION_CHART_DESCRIBES_TYPICAL' | translate }}
            </p>
          </div>

          <div *ngSwitchCase="documentType.RemediationQuestions" class="spacer-sm">
            <b>{{ 'REMEDIATION_MODAL.INTERVENTION_QUESTIONS' | translate }}</b>
            <p class="text-smp">
              {{ 'REMEDIATION_MODAL.THE_INTERVENTION_QUESTIONS_CAN_BE' | translate }}
            </p>
          </div>

          <div *ngSwitchCase="documentType.McReteach" class="spacer-sm">
            <b>{{ 'REMEDIATION_MODAL.RETEACH' | translate }}</b>
            <p class="text-smp">
              {{ 'REMEDIATION_MODAL.HELPS_STUDENTS_WHO_NEED_ADDITIONAL' | translate }}
            </p>
          </div>

          <div *ngSwitchCase="documentType.McExtension" class="spacer-sm">
            <b>{{ 'REMEDIATION_MODAL.EXTENSION' | translate }}</b>
            <p class="text-smp">
              {{ 'REMEDIATION_MODAL.THESE_EXERCISES_DEVELOP_CREATIVE_PROBLEMSOLVING' | translate }}
            </p>
          </div>

          <div *ngSwitchCase="documentType.McChapterOverviewAndProgression" class="spacer-sm">
            <b>{{ 'REMEDIATION_MODAL.CHAPTER_OVERVIEW_AND_PROGRESSION' | translate }}</b>
            <p class="text-smp">
              {{ 'REMEDIATION_MODAL.PROVIDES_TEACHERS_WITH_A_LOOK' | translate }}
            </p>
          </div>

          <div *ngSwitchCase="documentType.McTeacherResource" class="spacer-sm">
            <b>{{ 'REMEDIATION_MODAL.TEACHER_RESOURCE' | translate }}</b>
            <p class="text-smp">
              {{ 'REMEDIATION_MODAL.PROVIDES_STRUCTURAL_SUPPORTS_TO_ASSIST' | translate }}
            </p>
          </div>

          <div *ngSwitchCase="documentType.McKeyConceptInteractives" class="spacer-sm">
            <b>{{ 'REMEDIATION_MODAL.KEY_CONCEPT_INTERACTIVES' | translate }}</b>
            <p class="text-smp">
              {{ 'REMEDIATION_MODAL.PROVIDE_INTERACTIVE_DIGITAL_PRACTICE_WITH' | translate }}
            </p>
          </div>

          <div *ngSwitchCase="documentType.McLookingBack" class="spacer-sm">
            <b>{{ 'REMEDIATION_MODAL.LOOKING_BACK' | translate }}</b>
            <p class="text-smp">
              {{ 'REMEDIATION_MODAL.ALLOWS_TEACHERS_TO_TRACE_THE' | translate }}
            </p>
          </div>

        </ng-container>
      </ng-container>
    </div>
    </div>

    <div class="remediation-modal__button-container">
      <a class="btn btn-primary btn-sm remediation-modal__button" *ngFor="let document of logicalError.Documents" [routerLink]="getRemediationDocumentRoute(document)" [queryParams]="{classId: classInfo?.ClassId}" target="_blank">
        <span *ngIf="document.DocumentType === documentType.ResponsiveIntervention">{{ 'REMEDIATION_MODAL.VIEW_RESPONSIVE_INTERVENTION_RESOURCE' | translate }}</span>
        <span *ngIf="document.DocumentType === documentType.MathBackground">{{ 'REMEDIATION_MODAL.VIEW_MATH_BACKGROUND' | translate }}</span>
        <span *ngIf="document.DocumentType === documentType.MisconceptionChart">{{ 'REMEDIATION_MODAL.VIEW_MISCONCEPTION_CHART' | translate }}</span>
        <span *ngIf="document.DocumentType === documentType.RemediationQuestions">{{ 'REMEDIATION_MODAL.VIEW_INTERVENTION_QUESTIONS' | translate }}</span>

        <span *ngIf="document.DocumentType === documentType.McReteach">{{ 'REMEDIATION_MODAL.VIEW_RETEACH' | translate }}</span>
        <span *ngIf="document.DocumentType === documentType.McExtension">{{ 'REMEDIATION_MODAL.VIEW_EXTENSION' | translate }}</span>
        <span *ngIf="document.DocumentType === documentType.McChapterOverviewAndProgression">{{ 'REMEDIATION_MODAL.VIEW_CHAPTER_OVERVIEW_AND_PROGRESSION' | translate }}</span>
        <span *ngIf="document.DocumentType === documentType.McTeacherResource">{{ 'REMEDIATION_MODAL.VIEW_TEACHER_RESOURCE' | translate }}</span>
        <span *ngIf="document.DocumentType === documentType.McKeyConceptInteractives">{{ 'REMEDIATION_MODAL.VIEW_KEY_CONCEPT_INTERACTIVES' | translate }}</span>
        <span *ngIf="document.DocumentType === documentType.McLookingBack">{{ 'REMEDIATION_MODAL.VIEW_LOOKING_BACK' | translate }}</span>
      </a>
    </div>

    <div class="center spacer-md">
      <button khA11yActionButton class="kh-modal-close-button remediation-modal__link-button cursor text-lg" (click)="closeModal()" [khA11yLabel]="'A11Y_LABEL.CLOSE' | translate">{{ 'REMEDIATION_MODAL.CLOSE' | translate }}</button>
    </div>
  </div>
</div>
</div>
